import { create } from 'zustand';
import { RealtimeEvent } from '@prometeus/contracts';

interface Toast {
  id: string;
  message: string;
  variant: 'success' | 'error' | 'warning' | 'info';
}

interface EventBusState {
  toasts: Toast[];
  addToast: (message: string, variant?: Toast['variant']) => void;
  removeToast: (id: string) => void;
  handleRealtimeEvent: (event: RealtimeEvent) => void;
}

export const useEventBusStore = create<EventBusState>((set) => ({
  toasts: [],
  addToast: (message, variant = 'info') => {
    const id = Math.random().toString(36).substring(7);
    set((state) => ({ toasts: [...state.toasts, { id, message, variant }] }));
    setTimeout(() => {
      set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
    }, 5000);
  },
  removeToast: (id) => {
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
  },
  handleRealtimeEvent: (event) => {
    if (event.type === 'notification.toast') {
      const toastEvent = event as any;
      set((state) => {
        const id = Math.random().toString(36).substring(7);
        return {
          toasts: [
            ...state.toasts,
            {
              id,
              message: toastEvent.data.message,
              variant: toastEvent.data.variant || 'info',
            },
          ],
        };
      });
    }
  },
}));

